import _ from "lodash";
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

import { FilterHeader } from "@shared/table/headers/FilterHeader";
import { ColumnFiltersState } from "@tanstack/react-table";

type Props = {
    productNames: string[];
    columnFilters: ColumnFiltersState;
    setColumnFilters: Dispatch<SetStateAction<ColumnFiltersState>>;
};

export const ProductNameHeader = ({ productNames, columnFilters, setColumnFilters }: Props) => {
    const { t } = useTranslation(["modals"]);
    const options = _.uniqBy(
        productNames.map((p) => ({ key: p, label: p })),
        "key",
    );
    const current = (columnFilters.find((f) => f.id === "productName")?.value as string[] | undefined) ?? [];

    return (
        <FilterHeader
            title={t("modals:filterDialog.variants.product")}
            options={options}
            initialValues={Object.fromEntries(options.map((o) => [o.key, current.includes(o.key)]))}
            onSubmit={(values) => {
                const value = Object.keys(values).filter((k) => values[k]);
                setColumnFilters((prev) => {
                    const rest = prev.filter((f) => f.id !== "productName");
                    return value.length ? [{ id: "productName", value }, ...rest] : rest;
                });
            }}
        />
    );
};
